import { MainTemplate } from "@/components/templates";
import {
  StartUsingMikatanoBFMForm,
  StartUsingMikatanoBFMFormValues,
} from "@/components/organisms";
import {
  SendForgotPasswordMailMutation,
  useSendForgotPasswordMailMutation,
} from "@/generated/graphql";
import { spMode } from "@/hooks";
import React from "react";
import { useRouter } from "next/router";
import { PageTitle } from "@/components/molecules";
import { css } from "@emotion/react";
import useRollbarUtil from "../hooks/useRollbarUtil";

export const StartUsingMikatanoBFMPage = () => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();
  const router = useRouter();

  const [sendForgotPasswordMailMutation] = useSendForgotPasswordMailMutation({
    onCompleted: (data: SendForgotPasswordMailMutation) => {
      if (data.sendForgotPasswordMail) {
        router.push("/start-using-mikatano-bfm-completed");
      }
    },
    onError: getNotifyErrorHandlerForGraphQL(
      "Faild to send forgot password mail",
      "メールの送付に失敗しました"
    ),
  });

  const handleSubmit = async (formValues: StartUsingMikatanoBFMFormValues) => {
    await sendForgotPasswordMailMutation({
      variables: {
        input: {
          email: formValues.email,
          app: "bfm",
        },
      },
    });
  };

  return (
    <MainTemplate title="「Mikatano 資金管理」の利用開始手続き">
      <PageTitle
        mainTitle={
          <div css={mainTitle}>
            「Mikatano 資金管理」の利用開始手続き
            <br />
            Mikatano IDのパスワード発行
          </div>
        }
      />
      <div
        css={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
        }}
      >
        <div
          css={{
            width: "100%",
            maxWidth: "480px",
            textAlign: "center",
            [spMode]: {
              textAlign: "left",
            },
          }}
        >
          <p>
            「まとめて資金管理」は「Mikatano
            資金管理」へとリニューアルいたしました。（事前案内の詳細はこちら）
          </p>
          <p>
            Mikatano 資金管理にログインするためのパスワードの発行が必要です。
          </p>
          <p>
            「まとめて資金管理」でご利用のID（メールアドレス）を入力し
            各規約をご確認の上［登録］をお願いいたします。
          </p>
          <p>（開始手続きの詳細はこちらをご確認ください）</p>
        </div>
        <StartUsingMikatanoBFMForm onSubmit={handleSubmit} />
      </div>
    </MainTemplate>
  );
};

const mainTitle = css({
  textAlign: "center",
});
